import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import Flex from '../Flex';
import Text from '../Text';
import Radio from './Radio';
const RadioGroup = /*#__PURE__*/React.memo(_ref => {
  let {
    flexDirection = 'row',
    fontSize = 1,
    gutter = 18,
    items,
    name,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: flexDirection,
    fontSize: fontSize
  }, items.map((item, i) => /*#__PURE__*/React.createElement(Flex, {
    key: item.label,
    as: "label",
    sx: {
      alignItems: 'center',
      ml: i !== 0 && flexDirection === 'row' ? gutter : 0
    }
  }, /*#__PURE__*/React.createElement(Field, {
    name: name,
    value: item.value,
    checked: item.value === value,
    component: Radio
  }), /*#__PURE__*/React.createElement(Text, null, item.label))));
});
RadioGroup.propTypes = {
  items: PropTypes.array.isRequired
};
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;